<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/regrind/recycle/record/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shuikoupicihao')">
            <el-input v-model="yt.conditions.regrindBatchNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="yt.conditions.materialIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIdList"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIdList"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shuikouchanchuleixing')">
            <yi_dictionary_select :max="1" :type="'REGRIND_RECYCLE_TYPE'" :ids.sync="yt.conditions.type"></yi_dictionary_select>
          </el-form-item>
          <el-button @click="yt.get(1)" type="primary" plain size="mini">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="clear()" size="mini">{{ $t('chongzhi') }}</el-button>
          <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
        </el-form>
      </template>
      <template #buttonsR>
        <el-button :loading="exportLoading" size="mini" icon="yicon yicon-export" :title="$t('daochu')" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_material_management_regrind_recycle_record_delete_button')">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/regrind/recycle/record/delete')" v-burylog="{functionType: '用户行为', logType: '按钮点击', startData: {'s1': '水口回收记录(维尔)-删除'}}">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
  </div>
</template>

<script>
import XLSX from "xlsx";

export default {
  name: "web_material_management_regrind_recycle_record_list",
  data() {
    return {
      exportLoading: false,
      columns: [
        {
          label: 'shuikoupicihao',
          prop: 'regrindBatchNo'
        },
        {
          label: 'shengchangongdanhao',
          prop: 'wo.no'
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          sort: 'string',
          width: 180
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          sort: 'string',
          width: 200
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujumingcheng',
          prop: 'mould.name',
          sort: 'string',
          width: 130
        },
        {
          label: 'shuikouchanchuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'REGRIND_RECYCLE_TYPE',
        },
        {
          label: 'shuikoujingzhong(KG)',
          prop: 'weight'
        },
        {
          label: 'chengzhongshijian',
          prop: 'createTime',
          type: 'time',
          width: 180,
        },
        {
          label: 'huishoucaozuoren',
          prop: 'createByObject.nickname'
        },
        {
          label: "caozuo",
          type: "slot",
          width: 150,
          fixed: "right",
        },
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
    }, 300);
  },
  methods: {
    clear() {
      this.yt.conditions = {};
      this.yt.get(1);
    },
    exportExcel() {
      this.exportLoading = true;
      //查询表格
      this.http.get('/web/regrind/recycle/record/page?pageNum=1&pageSize=9999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => this.$t(i.label));
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows;
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i], tableFirst);
          tableData.push(dataArr);
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `水口回收记录_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      })
      .finally(() => {
        this.exportLoading = false;
      });
    },
    getTableDataArr(row,tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('shuikoupicihao'))] = row.regrindBatchNo;
      dataArr[tableFirst.indexOf(this.$t('shengchangongdanhao'))] = row.wo.no;
      dataArr[tableFirst.indexOf(this.$t('chanpinbianma'))] = row.material.code;
      dataArr[tableFirst.indexOf(this.$t('chanpinmingcheng'))] = row.material.name;
      dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = row.equipment.name;
      dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = row.mould.name;
      dataArr[tableFirst.indexOf(this.$t('shuikouchanchuleixing'))] = this.$t(this.store.state.dictJson['REGRIND_RECYCLE_TYPE'][row.type]);
      dataArr[tableFirst.indexOf(this.$t('shuikoujingzhong(KG)'))] = row.weight;
      dataArr[tableFirst.indexOf(this.$t('chengzhongshijian'))] = this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss');
      dataArr[tableFirst.indexOf(this.$t('huishoucaozuoren'))] = row.createByObject ? row.createByObject.nickname : '';
      return dataArr;
    }
  }
}
</script>

<style scoped>

</style>